'use client';

import { ChatContact } from '../../types/chat';

interface ChatHeaderProps {
  contact: ChatContact;
  onBack: () => void;
}

export function ChatHeader({ contact, onBack }: ChatHeaderProps) {
  return (
    <div className="flex flex-col border-b border-[#DEE2E7] bg-white">
      <div className="flex items-center justify-between p-4">
        <div className="flex items-center space-x-3">
          {/* Back button */}
          <button
            onClick={onBack}
            className="p-1 hover:bg-[#F5F7F9] rounded transition-colors duration-200"
            aria-label="뒤로 가기"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M19 12H5M12 19L5 12L12 5"
                stroke="#323B49"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>

          {/* Contact info */}
          <div className="flex items-center space-x-3">
            <div>
              <h2 className="font-medium text-[#323B49]">
                {contact.name}
              </h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}